import { render } from "./InputBtn.vue?vue&type=template&id=031c100a&scoped=true"
import script from "./InputBtn.vue?vue&type=script&lang=js"
export * from "./InputBtn.vue?vue&type=script&lang=js"

import "./InputBtn.vue?vue&type=style&index=0&id=031c100a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-031c100a"

export default script